import { FC } from 'react'

interface ProgressBarProps {
  percent?: number
}

export const ProgressBar: FC<ProgressBarProps> = ({ percent = 0 }: ProgressBarProps) => {
  let readyPercent = percent
  if (percent > 100) {
    readyPercent = 100
  }
  if (percent < 0) {
    readyPercent = 0
  }

  return (
    <div className="progress-line__container w-100">
      <div
        className="progress-line bg-primary"
        style={{ width: `${readyPercent}%` }}
      ></div>
    </div>
  )
}

//npm i --save-dev webpack webpack-cli webpack-dev-server esbuild-loader
